// extracted by mini-css-extract-plugin
export var item = "styles-module--item--1WKoZ";
export var itemSmall = "styles-module--itemSmall--BVbVD";
export var itemMedium = "styles-module--itemMedium--mIKIz";
export var itemLarge = "styles-module--itemLarge--2Jh5y";